

exports.smbCategories = {
    "Trademark Registration": true,
    "Small Business Loan Request Letter": true,
    "Breach of Contract": true,
    "Remove Negative Reviews and Photos": true
}